import {useContext} from 'react'
import clsx from 'clsx'
import {Card} from '@/components/Card'
import {CustomerContext} from '../../CustomerContext'
import {useIntl} from 'react-intl'

import {CustomerEmail} from '../../../core/_models'

const EmailsCard = () => {
  const {customer} = useContext(CustomerContext)
  const intl = useIntl()

  return (
    <Card
      title="Used emails"
      collapsable={false}
      className="card mb-2"
    >
      <div className="timeline">
        {(customer?.emails || []).map((e: CustomerEmail, index: number) => (
          <div key={`state-${index}`} className='timeline-item'>
            <div className='timeline-line w-40px'></div>

            <div className='timeline-icon symbol symbol-circle symbol-40px'>
              <div className='symbol-label'>
                <i className={clsx('fa fa-genderless fs-1 text-success', {
                  'text-danger': e.mx === false,
                  'text-warning': e.disposable,
                })}></i>
              </div>
            </div>

            <div className='timeline-content mb-5'>
              <div className='overflow-auto pe-3'>
                <div className='fs-5 fw-bold'>
                  {e.value}
                </div>

                <div className='d-flex align-items-center fs-6'>
                  <div className='text-muted me-2 fs-7'>
                    {intl.formatDate(e.validatedAt, {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric'
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

    </Card>
  )
}

export {EmailsCard}
